import academySrc1 from './assets/SKP-Academy.jpg';
import academySrc2 from './assets/Joico-Academy.jpg';

import educationalSrc1 from './assets/STMNT.jpg';
// import educationalSrc2 from './assets/ABC.jpg';
import educationalSrc3 from './assets/SexyHair.jpg';
import educationalSrc4 from './assets/Kenra.jpg';
import educationalSrc5 from './assets/Pravana.jpg';
import educationalSrc6 from './assets/Alterna.jpg';
import educationalSrc7 from './assets/DevaCurl.jpg';

export const getAcademy = (intl) => [
  {
    title: 'Schwarzkopf Professional E-Academy',
    link: '',
    linkLabel: intl.formatMessage({ defaultMessage: 'COMING SOON' }),
    imageSrc: academySrc1,
  },
  {
    title: 'Joico Pro Education',
    link: 'https://www.joico.ca/education-on-demand/',
    linkLabel: intl.formatMessage({ defaultMessage: 'EXPLORE NOW' }),
    imageSrc: academySrc2,
  },
];

export const educationalVideos = [
  {
    title: 'STMNT',
    link: 'https://www.youtube.com/@STMNTGroomingGoods',
    imageSrc: educationalSrc1,
  },
  // {
  //   title: 'Authentic Beauty Concept',
  //   link: 'https://www.youtube.com/@AuthenticBeautyConcept',
  //   imageSrc: educationalSrc2,
  // },
  {
    title: 'SexyHair',
    link: 'https://www.youtube.com/@SexyHair',
    imageSrc: educationalSrc3,
  },
  {
    title: 'Kenra',
    link: 'https://www.youtube.com/@KenraProfessional',
    imageSrc: educationalSrc4,
  },
  {
    title: 'Pravana',
    link: 'https://www.youtube.com/@pravana',
    imageSrc: educationalSrc5,
  },
  {
    title: 'Alterna',
    link: 'https://www.youtube.com/@alternahaircare',
    imageSrc: educationalSrc6,
  },
  {
    title: 'DevaCurl',
    link: 'https://www.youtube.com/@DevaCurl',
    imageSrc: educationalSrc7,
  },
];
